export default __webpack_public_path__ + "static/media/map-v2.34589de5.png";